import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import {
  MOBILE_BREAKPOINT,
  rydeColorsDashboardPage,
  rydeColorsGraphs,
} from "@ryde/theme";

export const NotificationItemStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "notification-item-styled",
})`
  width: 562px;
  border: 1px solid ${rydeColorsDashboardPage.dashboardCardBorder};
  border-inline-start-width: 2px;
  border-inline-start-color: ${rydeColorsGraphs.horizontalBarDefaultColor};
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 10px;
  gap: 15px;
  cursor: pointer;

  &.NotificationItem_inactive {
    opacity: 0.3;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 650px;
    max-width: 100%;
  }
`;
